function formatIngredients(ingredients) {

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);


    // Step 1: Group ingredients by type
    const grouped = ingredients.reduce((acc, item) => {
        const type = item.ingredient.ingredient_type.name;
        if (!acc[type]) acc[type] = []; // This checks if a key with the current type already exists in the acc object. If not, it creates a new empty array for that type
        acc[type].push(item); // The reducer function returns the updated acc object for the next iteration.
        return acc;
    }, {});
    
    // Step 2: Sort ingredients within each group by 'order' (if available)
    Object.values(grouped).forEach(group => {
        group.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)); // he ?? 0 is the nullish coalescing operator. If a.order is null or undefined, it defaults to 0.
    }); // This performs the comparison. If the result is negative, a comes before b. If positive, b comes before a. If zero, their order remains the same. This effectively sorts the ingredients in ascending order based on their order property (treating null or undefined as 0).

    // Step 3: Sort groups by the highest 'order' within the group
    // Object.entries(grouped) This transforms the grouped object into an array of key-value pairs, where each pair is an array [type, items]
    const sortedGroups = Object.entries(grouped).sort((a, b) => {  // a and b: These are arrays of the form [type, items] representing two different ingredient groups.
        const maxOrderA = Math.max(...a[1].map(item => item.order ?? 0)); // This finds the maximum order value within the ingredient group a. The spread syntax (...) expands the array of order values into individual arguments for Math.max
        const maxOrderB = Math.max(...b[1].map(item => item.order ?? 0));
        return maxOrderA - maxOrderB;
    });

    // Step 4: Format each ingredient
    let ecologicalFound = false;
    let formattedIngredients = sortedGroups.map(([type, items]) => {
        let formattedItems = items.map(item => {
            let formattedName = item.ingredient_name;
            
            // Mark allergens as bold
            if (item.ingredient.allergens) {
                formattedName = `<b>${formattedName}</b>`;
            }

            // Check if ingredient has an E-number
            if (item.ingredient.e_number) {
                formattedName += ` (E&nbsp;${item.ingredient.e_number.split(" ")[1]})`;
            }

            // Mark ecological ingredients with *
            if (item.ecological_agriculture) {
                ecologicalFound = true;
                formattedName += `*`;
            }

            return formattedName;
        });

        return `${type}: ${formattedItems.join(", ")}`;
    });

    // Step 5: Move "unter Schutzatmosphäre abgefüllt" to the end if present
    let protectionTextIndex = formattedIngredients.findIndex(text => text.includes("unter Schutzatmosphäre abgefüllt") || text.includes("bottled under protective atmosphere"));
    
    if (protectionTextIndex !== -1) {
        let protectionText = formattedIngredients.splice(protectionTextIndex, 1);
        formattedIngredients.push(`<i>${protectionText[0].split(': ')[1]}</i>`);
    }

    // Step 6: Append ecological agriculture note
    if (ecologicalFound) {
        const ecological_message = lang == 'de' ? "* aus biologischer Landwirtschaft" : "* from ecological agriculture"
        formattedIngredients.push(ecological_message);
    }

    return formattedIngredients.join("; ");
}

export default formatIngredients